// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__R3Jf6","footerText":"Footer_footerText__15f5F","mpsIcon":"Footer_mpsIcon__3T_HG"};